
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.7 20.7c.4-.4.4-1 0-1.4l-5.1-5.1c2.3-3.1 1.7-7.5-1.4-9.8S6.7 2.7 4.4 5.8s-1.7 7.5 1.4 9.8c2.5 1.9 5.9 1.9 8.4 0l5.1 5.1c.4.4 1 .4 1.4 0zM5 10c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z"}})])
          )
        }
      }
    